import{jsx as e,Fragment as r,jsxs as o}from"react/jsx-runtime";import{useState as n,useEffect as t,useCallback as i,useMemo as c}from"react";import d,{css as a}from"styled-components";const l=d.button`
	display: flex;
	flex-direction: row;
	padding: 8px;
	align-items: center;
	gap: 8px;
	border: none;
	background: ${({theme:e})=>e.bg.general};
	color: ${({theme:e})=>e.text.text};
	&:hover {
		cursor: pointer;
		background: ${({theme:e})=>e.bg.hover};
	}
`,p=d.div`
	position: fixed;
	z-index: 999;
	border-radius: 8px;
	border: 1px solid var(--border-black-10, rgba(0, 0, 0, 0.1));
	background: var(--Background-General, #fff);
	box-shadow: 0 3px 13px 0 rgba(0, 0, 0, 0.15);
	display: flex;
	flex-direction: column;
	overflow: hidden;
	${({x:e,y:r})=>a`
		top: ${r}px;
		left: ${e}px;
	`}
`,s=()=>{const[d,a]=n([]),[s,x]=n([]);t(()=>{const e=()=>x([]);return document.addEventListener("click",e),()=>{document.removeEventListener("click",e)}},[]);const m=i((e,r)=>{e.preventDefault(),x(r),a([e.pageX,e.pageY])},[]);return{contextMenu:c(()=>{if(!(null==s?void 0:s.length))return e(r,{});const n=s.some(e=>!!e.icon),t=r=>r?r():e("div",{});return e(p,Object.assign({x:d[0],y:d[1]},{children:s.map(({label:i,onClick:c,icon:d})=>o(l,Object.assign({onClick:c},{children:[n?t(d):e(r,{}),i]}),i))}))},[s,d]),handler:m}};export{l as MenuAction,p as MenuContainer,s as useContextMenu};
